import Cart from "@components/Cart";
import { MessageBase, MessageContainer } from "@components/elements/MessageContainer";
import { StreamlinedSelection } from "@hooks/recommendations/useStreamlinedSelection";
import { useTitle } from "@hooks/useTitle";
import { AlertBanner } from "@runwayhealth/runway-components-react";
import { RecommendedConditions } from "@types-runway/case";
import { formatCustomMarkdownToJsx } from "@utils/content/markdownFormatter";

type RecommendationResultsProps = {
  regionRecommendations: RecommendedConditions;
  comfortCareRecommendations: RecommendedConditions;
  selection: StreamlinedSelection;
};

const RecommendationResults = ({
  regionRecommendations,
  comfortCareRecommendations,
  selection,
}: RecommendationResultsProps) => {
  useTitle("Consultation Results");
  const formattedReason = formatCustomMarkdownToJsx(regionRecommendations.reason || "");

  return (
    <>
      {regionRecommendations.conditions.length > 0 && (
        <div className="upsell-page-body">
          <div className="wrapper">
            <Cart
              country="US"
              variant="region-based"
              preselectedConditions={regionRecommendations.conditions}
              addonConditions={selection.regionConditions}
              setAddonConditions={selection.setRegionConditions}
              cartItemPresentationStyle="selector"
              shouldDisplaySummary={false}
            />
            <hr></hr>
            <MessageBase variant="info" isRounded>
              <MessageContainer>
                <AlertBanner.Message>{formattedReason}</AlertBanner.Message>
              </MessageContainer>
            </MessageBase>
          </div>
        </div>
      )}
      {regionRecommendations.conditions.length > 0 &&
        comfortCareRecommendations.conditions.length > 0 && <hr></hr>}
      {comfortCareRecommendations.conditions.length > 0 && (
        <div className="upsell-page-body">
          <div className="wrapper">
            <Cart
              country="US"
              variant="comfort-care"
              preselectedConditions={comfortCareRecommendations.conditions}
              addonConditions={selection.comfortCareConditions}
              setAddonConditions={selection.setComfortCareConditions}
              initialIsSkipped={selection.hasSkippedComfortCare}
              onSkipChange={selection.setHasSkippedComfortCare}
              cartItemPresentationStyle="selector"
              shouldDisplaySummary={false}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default RecommendationResults;
